'use strict';

import Common from '../../Utils/Common'

/**
 * @classname EntryFilter
 * @classdesc 求人票の絞り込み
 */
export default class EntryFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('EntryFilter.constructor');
		this._$e = $e;

		if($e.find('input').length > 0) {
			this._$e = $e.find('input')
		}
		this._parameterName = this._$e.attr('name')
		this._type = this._$e.attr('data-search-type')

		// 各イベント
		if(this._type === 'checkbox'){
			this._$e.on('click', () => this.onEvent());
		}else if(this._type === 'select'){
			this._$e.on('change', () => this.onEvent());
		}

	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof EntryFilter
	 * @return {undefined}
	 */
	onEvent() {
		console.log('EntryFilter.onEvent');
		let url = Common.getCurrentURL()

		const value = this._$e.val()
		// 今のパラメータ取得
		// let params = this._getUrlParams();

		let params = [];
		const _$filters = $('.entry-filter')

		console.log('_$filters;;' + _$filters.length)

		_$filters.each((idx, e) => {
			let $self
			if($(e).find('input').attr('data-search-type') === 'checkbox'){
				$self = $(e).find('input')
			}else{
				$self = $(e); 
			}

			// const $self = $(e); 
			const pn = $self.attr('name')
			const value = $self.val()
			const type = $self.attr('data-search-type')

			console.log('ループない')
			console.log('パラメータtype::' + type)
			console.log('パラメータname::' + pn)
			console.log('パラメータvalue::' + value)

			// 未読であればパラメータをつける
			if(type === 'checkbox'){
				console.log('checkboxない')
				if($self.prop('checked')){
					console.log('checkboxのパラメータname::' + pn)
					console.log('checkboxのパラメータvalue::' + value)
					params[pn] = value
				}
			// 発行日が選択されていればパラメータをつける
			}else{
				if(value !== ''){
					params[pn] = value
				}
			}
		});


		// 未読であればパラメータをつける
		// if(this._type === 'checkbox'){
		// 	if(this._$e.prop('checked')){
		// 		params[this._parameterName] = value
		// 	}else{
		// 		if (params.hasOwnProperty(this._parameterName)) {
        //             delete params[this._parameterName];
        //         }
		// 	}
		// // 発行日が選択されていればパラメータをつける
		// }else{
		// 	if(value !== ''){
		// 		params[this._parameterName] = value
		// 	}else {
		// 		delete params[this._parameterName];
		// 	}
		// }
	
		let param = ''
		let prefix = '?';

		for (var name in params) {
			console.log('name::' + name)
			const values = params[name];
			param += `${prefix}${name}=${values}`;
			prefix = '&';

		}

		console.log(`${url}${param}`);
		location.href = `${url}${param}`;
	};

	_getUrlParams() {
        var params = [];
        var queryString = window.location.search.substring(1);
        var regex = /([^&=]+)=?([^&]*)/g;
        var match;

        while (match = regex.exec(queryString)) {
            var key = decodeURIComponent(match[1].replace(/\+/g, ' '));
            var value = decodeURIComponent(match[2].replace(/\+/g, ' '));
			console.log('今のパラメーター：' + key + ': ' + value);
            params[key] = value;
        }
        return params;
    }

};
